import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const SERVICES = [
  {
    id: "short-form",
    num: "01",
    title: "SHORT-FORM CONTENT",
    desc: "Reels, Shorts, and TikToks cut from the moments you already recorded.",
    tags: ["REELS", "SHORTS", "TIKTOKS"],
  },
  {
    id: "vlog",
    num: "02",
    title: "VLOG EDITING",
    desc: "Days out, trips, routines, and personal content shaped into stories worth watching.",
    tags: ["DAYS OUT", "TRIPS", "ROUTINES"],
  },
  {
    id: "event",
    num: "03",
    title: "EVENT RECAPS",
    desc: "Performances, parties, community events, speaking engagements, and gatherings.",
    tags: ["PERFORMANCES", "PARTIES", "GATHERINGS"],
  },
  {
    id: "business",
    num: "04",
    title: "BUSINESS & LIFESTYLE",
    desc: "For barbers, restaurants, clothing brands, gyms, and creators recording what they already do.",
    tags: ["BARBERS", "RESTAURANTS", "BRANDS", "GYMS"],
  },
];

export const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="bg-[#050505] px-5 py-24 sm:px-10 sm:py-36"
  >
    <div className="mx-auto max-w-7xl">
      <motion.span
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        className="mb-8 block font-mono text-[10px] uppercase tracking-[0.35em] text-[#8E8E93] sm:text-xs"
      >
        02 — SERVICES
      </motion.span>

      <div className="grid grid-cols-1 border-l border-t border-white/10 md:grid-cols-2">
        {SERVICES.map((s, i) => (
          <motion.button
            key={s.id}
            data-testid={`service-card-${s.id}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            onClick={() => scrollToId("contact")}
            className="group relative border-b border-r border-white/10 p-8 text-left transition-colors duration-500 hover:bg-[#121215] sm:p-12"
          >
            <div className="flex items-start justify-between">
              <span className="font-mono text-[10px] tracking-[0.3em] text-[#8E8E93]">{s.num}</span>
              <ArrowUpRight
                className="h-5 w-5 text-[#8E8E93] transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#E63946]"
                strokeWidth={1.5}
              />
            </div>
            <h3 className="mt-14 font-display text-3xl font-black uppercase leading-[0.95] tracking-tight text-[#F3F3F5] sm:mt-20 sm:text-5xl">
              {s.title}
            </h3>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-[#8E8E93]">{s.desc}</p>
            <div className="mt-8 flex flex-wrap gap-2">
              {s.tags.map((t) => (
                <span
                  key={t}
                  className="border border-white/10 px-3 py-1 font-mono text-[9px] uppercase tracking-[0.25em] text-[#8E8E93]"
                >
                  {t}
                </span>
              ))}
            </div>
          </motion.button>
        ))}
      </div>

      <motion.button
        data-testid="service-card-custom"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay: 0.2 }}
        onClick={() => scrollToId("contact")}
        className="group flex w-full flex-col items-start justify-between gap-4 border-b border-l border-r border-white/10 p-8 text-left transition-colors duration-500 hover:bg-[#121215] sm:flex-row sm:items-center sm:p-10"
      >
        <div>
          <span className="font-mono text-[10px] tracking-[0.3em] text-[#8E8E93]">05</span>
          <h3 className="mt-2 font-display text-2xl font-black uppercase tracking-tight text-[#F3F3F5] sm:text-3xl">
            CUSTOM EDIT
          </h3>
          <p className="mt-2 text-sm text-[#8E8E93]">
            Footage that refuses to fit a category? Send it anyway.
          </p>
        </div>
        <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-[#8E8E93] transition-colors group-hover:text-[#E63946]">
          TELL ME THE IDEA <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
        </span>
      </motion.button>
    </div>
  </section>
);
